import { createSelector } from 'reselect'
import { ProductType } from 'apollo/generated/globalTypes'
import type { RootState } from 'common/types/Global'
import type { ProductShape } from 'models/Product'
import { ReduxState } from 'store/types'

export const getProduct = (
  state: Partial<RootState>,
): ProductShape & { brandFullInfo: any } => {
  const productFromState =
    state.sessionData.products[state.globalFilters.product]

  const product = {
    ...productFromState,
    brandFullInfo: state.sessionData.brands.find(
      brand => brand.id === productFromState.brandId,
    ),
  }

  return product
}

export const isMultiFeedSelector = createSelector(getProduct, ({ type }) =>
  [
    ProductType.RACE,
    ProductType.EXPLORE,
    ProductType.REVIEW_BENCHMARK,
  ].includes(type as any),
)

export const productSelector = createSelector(getProduct, view => view)

export const simpleProductSelector = createSelector(
  [
    (state: ReduxState) =>
      state.sessionData.products[state.filters.query.product],
  ],
  product => product,
)
